import React, {Fragment} from 'react';
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import _ from "lodash";
import createLink from "../../../libs/createLink";

import {fetchTagsProtagonist} from "../../../creators/tagsProtagonist";
import {fetchTagsStories} from "../../../creators/stories.tagsStories";
import {fetchUserArticles, resetUserArticles} from "../../../creators/user.articles";
import {createStory, fetchStory, updateStory} from "../../../creators/story";

import {Button} from "../Button";
import {
    CheckboxInputField,
    RadioInputField,
    SearchTextInputField,
    SelectField,
    TextAreaField,
    TextInputField
} from "../FormField";
import TagList from "../TagList";
import AutocompletedTag from "../AutocompletedTag";
import {Can} from "../../../ability-context";
import {PageLoader} from "../Loader";
import Modal from "../Modal";
import AdvancedEditorArticle from "./AdvancedEditorArticle";


class AdvancedEditorStory extends React.Component {
    constructor(props){
        super(props);
        this.tagsIsReal = [{_id : false, title : "Création / fantasme"}, {_id : true, title : "Histoire réelle"}];
        this.tagsIsHard = [{_id : false, title : "Erotique"}, {_id : true, title : "Hard"}];
        this.status = [{_id : 0, title : "En attente de validation"}, {_id : 1, title : "Accepter"}, {_id : 2, title : "Refuser"}];
        this.initialFilter = {
            limit: 20,
            search: "",
        };
        this.initialStory = {
            title : "",
            content: {
                _id: "",
            },
            excerpt: "",
            tags: [],
            protagonist : 0,
            isHard : false,
            isReal : false,
            status : 0
        };
        this.state = {
            story: this.initialStory,
            filter : this.initialFilter,
            addTag: '',
            // type: "",
            // softness: "",
            termsAgreed: false,
            allowToCorrect: true,

            titleError: false,
            excerptError: false,
            protagonistError : false,
            typeError: false,
            // softnessError: false,
            contentError: false,
            termsAgreedError: false,
            allowToCorrectError: false,
            isUserArticle : false,
            toggleCreateArticle : false
        };

        this.handleValue = this.handleValue.bind(this);
        this.handleStoryValue = this.handleStoryValue.bind(this);
        this.SelectTags = this.SelectTags.bind(this);
        this.handleTagProtagonist = this.handleTagProtagonist.bind(this);
        this.removeTags = this.removeTags.bind(this);
        this.handleAddTag = this.handleAddTag.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.getUserArticles = _.debounce(this.getUserArticles, 300).bind(this);
        this.handleAddArticle = this.handleAddArticle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.addCustomTag = this.addCustomTag.bind(this);
        this.handleCloseModalArticle = this.handleCloseModalArticle.bind(this);
        this.handleSubmitMessageTimeout = this.handleSubmitMessageTimeout.bind(this);
        this.props.fetchTagsProtagonist({
            isActive : true
        });
        // this.props.fetchTagsStories({
        //     optionFilter: "story",
        //     sort: "option.order"
        // });
        this.getUserArticles(this.state.filter);

        if(this.props.storyId){
            this.props.fetchStory(this.props.storyId, {nocache : true});
        }
    }


    componentDidUpdate(prevProps) {
        if(prevProps.story !== this.props.story && this.props.storyId){
            // let storyCat1 = this.props.story.tags.filter(item =>item.option.filter === "story" && item.option.group === 1);
            // let storyCat2 = this.props.story.tags.filter(item =>item.option.filter === "story" && item.option.group === 2);
            let tagProtagonistIds = this.props.tagsProtagonist.map(item => item._id);
            let isProtagonist = this.props.story.tags.filter(item => tagProtagonistIds.includes(item._id));
            let tags = this.props.story.tags.filter(item => !tagProtagonistIds.includes(item._id));

            this.setState({story: {
                    ...this.state.story,
                    title: this.props.story.title,
                    tags: tags,
                    excerpt: this.props.story.excerpt,
                    content: this.props.story.content,
                    isReal : this.props.story.isReal,
                    isHard : this.props.story.isHard,
                    status : this.props.story.status,
                    protagonist : _.get(isProtagonist, "isProtagonist[0]._id") || ""
                },
                // type: storyCat1[0]._id,
                // softness: storyCat2[0]._id,
            });
        }
         if(prevProps.userArticlesInitialized !== this.props.userArticlesInitialized && this.props.userArticlesInitialized){
             this.setState({isUserArticle : this.props.userArticlesTotal !== 0});
         }
    }

    componentWillUnmount() {
        this.props.resetUserArticles();
    }

    handleValue(name, value){
        this.setState({[name]: value});
    }

    handleStoryValue(name, value){
        this.setState({story: {...this.state.story, [name]: value}});
    }

    handleSearch(value){
        this.setState({filter: {...this.state.filter, search: value}});
        this.getUserArticles({...this.state.filter, search: value});
    }

    getUserArticles(filter){
        let query = {...filter};
        this.props.fetchUserArticles(this.props.currentUserId, query);
    }

    SelectTags(propsTags) {
        let currentTags = this.state.story.tags;
        let selected = 0;
        propsTags.forEach(item => {
            if (currentTags.includes(item._id)) {
                selected = item._id;
                return item._id;
            }
        });
        return selected;
    }

    handleTagProtagonist(id) {
        /*let tag = this.props.tagsProtagonist.filter(item => item._id === id);
        let tagsState = this.state.story.tags.filter(item => item._id.toString() !== id.toString());
        if (tag && tag[0]) {
            // console.log({story : {...this.state.story, tags: [...this.state.story.tags, tag[0]]}});
            this.setState({story : {...this.state.story, tags: [...tagsState, tag[0]]}})
        }*/
        this.setState({story : {...this.state.story, protagonist: id}})
    }


    handleKeyPress(event) {
        if (event.key === "Enter" && this.state.addTag.length >= 1 && this.state.story.tags.length <= 9) {
            // let tags = [...this.state.story.tags, {title: this.state.addTag}];
            // this.setState({addTag: "", story : {...this.state.story, tags}});
            // if (typeof (this.props.handleTags) !== "undefined") {
            //     this.props.handleTags(tags);
            // }
            this.addCustomTag();
        }
    }

    addCustomTag(tag){
        if(this.state.story.tags.length <= 9) {
            let tags = this.state.story.tags;
            let protagonist = this.state.story.protagonist;
            let isOfficialTag = this.props.tagsProtagonist.filter(item => item.title.toLowerCase() === tag.title.toLowerCase());

            if (isOfficialTag && isOfficialTag[0]) {
                protagonist = isOfficialTag[0]._id;
                //tags = tags.filter(item => item._id.toString() !== isOfficialTag[0]._id.toString());
                //tags.push(isOfficialTag[0]);
            }
            else{
                tags.push(tag);
            }
            this.setState({story : {...this.state.story, tags, protagonist}});
        }
    }

    handleAddTag(event) {
        this.setState({addTag: event.target.value})
    }

    removeTags(currentIndex) {
        let tags = this.state.story.tags;
        tags.splice(currentIndex, 1);
        this.setState({story: {...this.state.story, tags}});
    }

    handleAddArticle(listElement){
        this.setState({
            filter: {...this.state.filter, search: ""},
            story: {...this.state.story, content: {_id: listElement._id, title: listElement.title}}
        });
    }

    handleSubmit(){
        setTimeout(()=>{
            this.handleSubmitMessageTimeout();
        },50)
    }

    handleSubmitMessageTimeout(){
        if(this.state.story.title.length !== 0 &&
            this.state.story.protagonist !== "0" &&
            this.state.story.content._id !== "" &&
            // this.state.story.content._id.length !== 0 &&
            this.state.story.excerpt.length !== 0 &&
            // this.state.type.length !== 0 &&
            // this.state.softness.length !== 0 &&
            ((this.state.termsAgreed &&
            this.state.allowToCorrect) || this.props.storyId)
        )
        {
            let story = this.state.story;
            let isProtagonist = this.props.tagsProtagonist.filter(item => item._id === story.protagonist);
            if(isProtagonist && isProtagonist[0]){
                story.tags.push(isProtagonist[0]);
            }

           if(this.props.storyId){
                this.props.updateStory(this.props.storyId, story);
            } else {
                this.props.createStory(story);
            }
            this.props.handleClose();
        }

        if(this.state.story.title.length === 0){
            this.setState({titleError: true});
        } else {
            this.setState({titleError: false});
        }

        if(this.state.story.content && this.state.story.content._id.length === 0){
            this.setState({contentError: true});
        } else {
            this.setState({contentError: false});
        }

        if(this.state.story.excerpt.length === 0){
            this.setState({excerptError: true});
        } else {
            this.setState({excerptError: false});
        }

        if(this.state.story.protagonist === "0"){
            this.setState({protagonistError: true});
        } else {
            this.setState({protagonistError: false});
        }

        // if(this.state.type.length === 0){
        //     this.setState({typeError: true});
        // } else {
        //     this.setState({typeError: false});
        // }
        //
        // if(this.state.type.length === 0){
        //     this.setState({softnessError: true});
        // } else {
        //     this.setState({softnessError: false});
        // }

        if(!this.state.termsAgreed){
            this.setState({termsAgreedError: true});
        } else {
            this.setState({termsAgreedError: false});
        }

        if(!this.state.allowToCorrect){
            this.setState({allowToCorrectError: true});
        } else {
            this.setState({allowToCorrectError: false});
        }
    }

    handleCloseModalArticle(){
        this.props.resetUserArticles();
        this.getUserArticles(this.state.filter);
        this.setState({toggleCreateArticle : false});
    }

    render(){

        return(
            <div className={"advanced-editor modal-container"}>
                <div className={"modal-topline"}>
                    <div>{this.props.storyId ? "Modification d'une histoire" : "Création d'une histoire"}</div>
                </div>

                {!this.props.userArticlesInitialized && this.props.userArticlesLoading ? (
                    <PageLoader />
                ) : null}
                {this.props.userArticlesInitialized  && !this.props.userArticlesLoading && !this.state.isUserArticle ? (
                    <div className={"text-danger text-align-center mt-8"}>
                        Avant de soumettre une histoire, il faut d'abord que vous l'écriviez dans un article.
                        <Can action={"create"} subject="Article">
                            <span
                                className={"create-article"}
                                onClick={()=>this.setState({toggleCreateArticle: true})}
                            >
                                Créer un article
                            </span>
                        </Can>
                    </div>

                ) : null}
                {this.props.userArticlesInitialized && this.state.isUserArticle ? (
                    <Fragment>
                        <div className={"modal-body"}>
                            <div className={"main"}>
                                <div className={"inner-block"}>
                                    <span className={"input-label"}>Titre de l'histoire</span>
                                    <TextInputField value={this.state.story.title}
                                                    placeholder={"Titre de votre histoire"}
                                                    error={this.state.titleError}
                                                    onChange={(event)=>this.handleStoryValue("title", event.target.value)} />
                                </div>

                                <div className={"inner-block"}>
                                    <span className={"input-label"}>Auquel de vos articles votre histoire doit-elle être rattachée ?</span>
                                    {!this.props.storyId && (
                                        <div className={"group-search"}>
                                            <SearchTextInputField value={this.state.filter.search}
                                                                  loading={this.props.userArticlesLoading}
                                                                  total={this.props.userArticlesTotal}
                                                                  placeholder={"Rechercher un article"}
                                                                  error={this.state.contentError}
                                                                  list={this.props.userArticles}
                                                                  getItem={this.handleAddArticle}
                                                                  handleSearch={this.handleSearch} />
                                            <Can action={"create"} subject="Article">
                                                <Button size={"small"}
                                                        className={"ml-16"}
                                                        btnStyle={"primary-reverse"}
                                                        onClick={()=>this.setState({toggleCreateArticle: true})}
                                                        content={"Créer un article"}/>
                                            </Can>
                                        </div>
                                    )}
                                    {this.state.story && this.state.story.content && this.state.story.content._id.length >= 1 && (
                                        <div className={"current-selected-article"}>
                                            Article selectionné : <b>{this.state.story.content.title}</b> &nbsp;
                                            {!this.props.storyId && (
                                                <Fragment>
                                                    -
                                                    <span onClick={()=>this.setState({
                                                        currentArticleName: "",
                                                        story: {...this.state.story, content:{_id : ""}}})}
                                                          className={"delete-current-article"}
                                                    >
                                                Supprimer
                                            </span>
                                                </Fragment>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className={"inner-block"}>
                                    <span className={"input-label"}>Création / fantasme ou histoire réelle ?</span>
                                    {this.tagsIsReal.map(item => (
                                        <RadioInputField checked={this.state.story.isReal === item._id}
                                                         key={item._id}
                                                         label={item.title}
                                                         id={item.title}
                                                         name={"isReal"}
                                                         htmlFor={item.title}
                                                         onChange={() => this.handleStoryValue("isReal", item._id)} />
                                    ))}
                                </div>

                                <div className={"inner-block"}>
                                    <span className={"input-label"}>Histoire érotique ou hard ?</span>
                                    {this.tagsIsHard.map(item => (
                                        <RadioInputField checked={this.state.story.isHard === item._id}
                                                         key={item._id}
                                                         label={item.title}
                                                         id={item.title}
                                                         name={"isHead"}
                                                         htmlFor={item.title}
                                                         onChange={() => this.handleStoryValue("isHard", item._id)} />
                                    ))}
                                </div>

                                <div className={"inner-block"}>
                                    <span className={"input-label"}>Résumé de l'histoire en quelques phrases</span>
                                    <TextAreaField value={this.state.story.excerpt}
                                                   className={"excerpt-textarea"}
                                                   error={this.state.excerptError}
                                                   onChange={(event)=>this.handleStoryValue("excerpt", event.target.value)} />
                                </div>

                                <div className={"inner-block"}>
                                    {/*<SelectField value={this.SelectTags(this.props.tagsProtagonist)}
                                         onChange={(event) => this.handleTagProtagonist(event.target.value)}
                            >
                                <option value={0}>Protagonistes</option>
                                {this.props.tagsProtagonist.map((item, index) =>
                                    <option value={item._id} key={index}>{item.title}</option>
                                )}
                            </SelectField>*/}
                                    <SelectField
                                        value={this.state.story.protagonist}
                                        onChange={(event) => this.handleTagProtagonist(event.target.value)}
                                        error={this.state.protagonistError}
                                    >
                                        <option value={0}>Protagonistes</option>
                                        {this.props.tagsProtagonist.map((item, index) =>
                                            <option value={item._id} key={index}>{item.title}</option>
                                        )}
                                    </SelectField>
                                </div>

                                <div className={"inner-block"}>
                                    <div className="row align-flex-end full add-tag-container">
                                        {this.state.story.tags.length < 10 && (<AutocompletedTag tagBlackListIds={this.props.tagsProtagonist.map(item => item._id)} addTag={this.addCustomTag} />)}
                                        {/*{this.state.story.tags.length < 10 && (<input*/}
                                        {/*    type="text"*/}
                                        {/*    className="bottom-bar-style"*/}
                                        {/*    placeholder="Ecrivez votre tag ici ..."*/}
                                        {/*    value={this.state.addTag}*/}
                                        {/*    onChange={(event) => this.handleAddTag(event)}*/}
                                        {/*    onKeyPress={(event) => this.handleKeyPress(event)}*/}
                                        {/*    maxLength="29"*/}
                                        {/*    minLength="1"*/}
                                        {/*/>)}*/}
                                        {/*{this.state.story.tags.length < 10 && (<span*/}
                                        {/*    className={`row no-shrink max-characters mx-4 ${this.state.addTag.length === 29 ? 'max-reached' : ''}`}>({this.state.addTag.length} / 29 caractères)</span>)}*/}
                                        <TagList tags={this.state.story.tags} removeTags={this.removeTags}/>
                                    </div>

                                </div>
                                {this.props.storyId && (
                                    <Can action={"update-status"} subject="Story">
                                        <div className={"inner-block"}>
                                            <span className={"input-label"}>Etat ?</span>
                                            {this.status.map(item => (
                                                <RadioInputField checked={this.state.story.status === item._id}
                                                                 key={item._id}
                                                                 label={item.title}
                                                                 id={item.title}
                                                                 name={"status"}
                                                                 htmlFor={item.title}
                                                                 onChange={() => this.handleStoryValue("status", item._id)} />
                                            ))}
                                        </div>
                                    </Can>
                                )}
                                {!this.props.storyId && (
                                    <div className={"inner-block"}>
                                        <CheckboxInputField checked={this.state.termsAgreed}
                                                            required={true}
                                                            onChange={() => this.handleValue("termsAgreed", !this.state.termsAgreed)}
                                                            label={`Je certifie que mon texte respecte les règles fixées par Voissa.`}
                                                            error={this.state.termsAgreedError}
                                                            id={"termsAgreed"}
                                                            htmlFor={"termsAgreed"}/>
                                        <p className={"infos-span"}> Vous pouvez voir les&nbsp;
                                            <Link to={createLink("storiesRules")} target={"_blank"} rel="noopener noreferrer">règles ici</Link>
                                        </p>
                                    </div>
                                )}
                                {!this.props.storyId && (
                                    <div className={"inner-block"}>
                                        <CheckboxInputField checked={this.state.allowToCorrect}
                                                            required={true}
                                                            onChange={() => this.handleValue("allowToCorrect", !this.state.allowToCorrect)}
                                                            label={"J'autorise que mon histoire soit corrigée sur la forme (fautes etc.)"}
                                                            error={this.state.allowToCorrectError}
                                                            id={"allowToCorrect"}
                                                            htmlFor={"allowToCorrect"}/>
                                    </div>
                                )}

                            </div>
                        </div>
                        {this.props.storyId && this.props.currentUserId?.toString() === this.props.story?.owner?._id.toString() && this.props.story.status === 1 ? <p className={"text-updated"}>ATTENTION : si vous validez les changements votre histoire sera désactivé le temps de la moderation</p> : null}
                        <div className={"modal-baseline"}>
                            <Button btnStyle={"grey"}
                                    size={"small"}
                                    onClick={()=>this.props.handleClose()}
                                    content={"Annuler"}/>
                            <Button btnStyle={"primary-reverse"}
                                    onClick={()=>this.handleSubmit()}
                                    size={"small"}
                                    content={this.props.storyId ? "Editer l'histoire" : "Publier l'histoire"}/>
                        </div>
                    </Fragment>
                    ) : null}

                <Modal toggle={this.state.toggleCreateArticle} handleClose={()=>this.setState({toggleCreateArticle: false})}>
                    <AdvancedEditorArticle handleClose={()=>this.handleCloseModalArticle()} />
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUserId : state.currentUser.data && state.currentUser?.data?._id,

        tagsStories: state.tagsStories.data,
        tagsStoriesLoading: state.tagsStories.loading,

        tagsProtagonist: state.tagsProtagonist.data,
        tagsProtagonistLoading: state.tagsProtagonist.loading,

        story: state.story.data,

        userArticles: state.userArticles.data,
        userArticlesLoading: state.userArticles.loading,
        userArticlesInitialized: state.userArticles.initialized,
        userArticlesTotal: state.userArticles.total
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchTagsProtagonist,
    fetchTagsStories,

    fetchUserArticles,
    resetUserArticles,

    fetchStory,
    updateStory,

    createStory,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedEditorStory);